import { clsx } from '@wonderful/wwc/dist/src/helpers/clsx';
import DOMPurify from 'isomorphic-dompurify';
import { useState } from 'react';

import { BuilderEditingHelper } from '@wonderful/wwc/dist/src/common/BuilderEditingHelper/BuilderEditingHelper';
import BuilderImage from '@/components/common/BuilderImage/BuilderImage';
import Section from '@/components/design/Section/Section';
import { Breakpoints } from '@/helpers/constants';

import { WhoWeAreProps } from './WhoWeAre.types';
import styles from './WhoWeAre.module.scss';

export default function WhoWeAre(props: WhoWeAreProps) {
  const { heading, image, textHeading, textSubHeading, textField } = props;

  const isVisible =
    !heading && !image && !textHeading && !textSubHeading && !textField;

  const [isInViewport, setIsInViewport] = useState({
    heading: false,
    textContent: false,
  });

  return (
    <Section className={clsx(styles.whoWeAreContainer)}>
      <BuilderEditingHelper componentName="WhoWeAre" visible={isVisible} />
      <Section
        className={clsx(isInViewport.heading ? styles.inViewport : '')}
        onEnterViewport={() =>
          setIsInViewport(state => ({ ...state, heading: true }))
        }
      >
        <h1 className={styles.heading}>{heading}</h1>
      </Section>
      <div className={styles.heroContainer}>
        <BuilderImage
          imageSrc={image?.src}
          alt={image?.altText}
          classes={styles.heroImage}
          mobileWidth={`${Breakpoints.md}px`}
          tabletWidth={`${Breakpoints.lg}px`}
          desktopWidth={`${Breakpoints.xxl}px`}
        />
      </div>
      <Section
        className={clsx(
          'container',
          styles.textContentContainer,
          isInViewport.textContent ? styles.inViewport : ''
        )}
        onEnterViewport={() =>
          setIsInViewport(state => ({ ...state, textContent: true }))
        }
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.textContentWrapper}>
              <div className={styles.textContent}>
                <h2>{textHeading}</h2>
                <br />
                <p>
                  <strong>{textSubHeading}</strong>
                </p>
                <div className={styles.paragraphs}>
                  {textField && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(textField),
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </Section>
  );
}
